let Status2CN = {
   'Y': '禁用',
  'N': '启用',
  'Approved': '审核通过',
  'Rejected': '审核不通过',
  'Pending Approval': '待审核',
   'Re-Allocated':'审核通过',
  'Active' : '已生效',
  'Expired' : '已失效',
  'UnActive' : '未生效',
  'Processing': '已放款',
  'Settled': '已还清',
  'Pending': '待处理',
  'Ready': '待生效',
  'Financing_Processing': '还款中',
  'Financing_Ready': '待放款',
  'Financing_Settled': '已还清',
  'Financing_Rejected':'已作废',
  'Pay_Processing': '已放款',
  'Pay_Ready': '待放款',
  'Pay_Paying':'放款中',
  'Pay_Settled': '已放款',
  'Pay_Rejected':'已作废',
  'Yearly': '年利率',
  'Monthly': '月利率',
  'Daily': '日利率',
  'Rate': '比率',
  'Amount': '固定值',
  'Sex_M': '男',
  'Sex_F': '女',
  'Sex_X': '保密',
  'PAY':'提款',
  'REPAY':'还款',
  'CustomerStatus_Active': '启用',
  'CustomerStatus_Prospective':'待激活',
  'capi/financing/RepayOnline':'第三方在线支付',
  'financing/RepayBank':'转账' ,
  'financing/RepayOffline' :'线下还款',
  'financing/PayFinancing':'人工放款',
  'kjt_inbound':'快捷通',
  'CCB/CCIP':'建行银企直联',
  'kjt_outbound':'快捷通',
  'KF':'审查授信',
  'FK':'风控审核',
  'ZJL':'总经理审核',
  'DSZ':'董事长审核',
  'ZHG':'综合岗审核',
    'FZ':'副总审核',
  'ZS':'终审',
  'DYSC':'抵押审核',
  'DYFK':'风控审核',
  'DEBX':'等额本息',
  'XXHB':'先息后本',
  'CIB':'兴业银行',
  'CMB':'招商银行',
  'None':'转入下期',
  'Refund':'返还客户',
  'Refund-ToDealer':'返还渠道商',
  'Profit':'记入营业外收入',
  'Repay':'还款',
  'Repay In Advance':'提前还款',
  'Other':'其他业务',
  'YW':'业务经办',
  'QR':'财务经办',
  'FH':'财务复核',
  'NQ':'内勤核实',
  'CWFH':'财务复核',
  'CWZJ':'财务审核',
    'ZFLR':'支付录入',
    'ZFSH':'支付审核',
  'Loan__Approved': '审核通过',
  'Loan__Rejected': '已退回',
  'Loan__Void': '作费',
  'Loan__Pending Approval': '待审核',
  'Loan__Completed': '放款成功',
  'TLT':'通联支付',
  'BANKTRANSFER':'网银转账',
  'InterestRevenueList_N':'人工确认',
  'InterestRevenueList_Y':'自动确认',
  'DA':'缴纳',
  'DR':'退还',
  'Deposit__Pending Approval':'待复核',
  'Deposit__Approved':'复核通过',
  'Deposit__Rejected':'否决',
  'Request__Open':'待分配',
  'Request__Ready':'已分配',
  'Request__Completed':'已受理',
  'Request__Void':'已取消',
  'OUT':'已出库',
  'IN':'已入库',
    'TRANSIT':'出库中',
    'HWI':'出库',
    'HWR':'入库',
    'alloc__X':'未分配',
    'alloc__Pending':'待受理',
    'alloc__Completed':'贷款成功',
    'alloc__Cancelled':'已撤回',
    'alloc__Rejected':'已被拒贷',
    'plan__Pending':'未还',
    'plan__Settled':'已还',
    'A':'助贷机构',
    'B':'资管公司',
    'C':'技术服务',
    'ZRR':'转让人',
    'SRR':'受让人',
    'p__Active' : '启用',
    'p__Expired' : '已失效',
    'p__UnActive' : '禁用',
    'YZZ':'已债转',
    'TX__YZZ':'审核通过',
    'CLWC':'已清收',
    'SSZ':'诉讼中',
    'Financing_':'',
    'QY':'签约用印',
    'CY':'撤押用印',
    'ZZ':'债转用印',
    'ZDH':'助贷函件用印',
    'FWF':'服务费支付用印',
    'SS':'诉讼用印',
    'TY':'业务相关用印',
    'ZHGZ':'综合岗（公章）',
    'ZHFRZ':'综合岗（法人章）',
    'CWCS':'财务初审',
    'CWSH':'财务审核',
    'ZJSH':'财务总监审核',
    '':'',//流程节点重新发起状态无值
    'reStart':'重新发起',
    //分公司指派状态
    'branch__alloc__Pending':'已指派',
    'branch__alloc__Void':'已撤回',
    'branch__alloc__Cancelled':'已取消',
    'branch__alloc__Ready':'待签约',
    'branch__alloc__Completed':'签约完成',
    'branch__alloc__Signing':'面签中',
    'branch__alloc__Completing':'面签完成、待用印',
    'a__Pending Approval':'待审核',
    'a__Approved':'待面签',
    'a__Rejected':'审核不通过',
    'a__Cancelled':'已取消',
    'a__Completed':'已完成',
    'a__Expired':'已过期',
    'assignmentStatus__Pending':'待处理',
    'assignmentStatus__Cancelled':'已取消',
    'assignmentStatus__Processing':'处理中',
    'assignmentStatus__Completed':'已完成',
    's__Signing':'面签中',
    's__Completing':'面签完成、待用印',
    's__Completed':'面签完成',
    's__Cancelled':'面签取消',
    's__Expired':'已过期',
    'Approve':'审核预约',
    'Signing':'面签',
    'Completed':'完成',
    'Ended':'结束',
    'fwjd':'房屋尽调',
    'YWFZR':'业务负责人',
    'FWFXG':'法务风险岗',
    'FGLD':'分管领导',
    'CWJB':'财务经办',
    'FZSH':'副总审核',
    'XMSQR':'项目申请人',
    'FKSH':'风控审核',
    'FR':'法人审核',
    'FLWJSH':'法律文件审核',
    'Withdrawn':'已撤回',
    'YWFZSH':'业务副总审核',

    'cpws':'裁判文书',
    'zxgg':'执行公告',
    'shixin':'失信公告',
    'ktgg':'开庭公告',
    'fygg':'法院公告',
    'sifacdk':'司法查冻扣',
    'ajlc':'案件流程',
    'bgt':'曝光台',
    'pmgg':'拍卖公告',
    'satparty_qs':'欠税公告',
    'satparty_chufa':'涉税处罚公示',
    'satparty_fzc':'税务非正常户公示',
    'satparty_xin':'纳税信用等级',
    'satparty_reg':'税务登记',
    'satparty_xuke':'税务许可',
    'epbparty':'环保处罚',
    'epbparty_jkqy':'重点监控企业名单',
    'epbparty_zxjc':'环保企业自行监测结果',
    'epbparty_huanping':'环评公示数据',
    'custom_xuke':'海关许可',
    'custom_credit':'海关信用等级',
    'custom_punish':'海关处罚信息',
    'custom_qy':'海关企业信息',
    'fdaparty':'食药监&市场监管',
    'credit_chufa':'信用处罚',
    'credit_xuke':'信用许可',
    'job':'招聘信息',
    'news':'新闻舆情',
    'pbcparty':'央行行政处罚',
    'pbcparty_cbrc':'银保监会行政处罚',
    'pbcparty_csrc_chufa':'证监处罚公示',
    'pbcparty_csrc_xkpf':'证监许可批复',
    'safe_chufa':'外汇局处罚',
    'safe_xuke':'外汇局许可',
    'xzhmd':'受惩黑名单(历史)',
    'company_gqcz':'股权出质',
    'company_dcdy':'动产抵押',
    'credit_ztbcf':'招投标行政处罚',
    'credit_tscl':'投诉处理',
    'credit_sxxw':'失信记录',
    'credit_jdcf':'监督处罚/检查处罚',
    'company_dcrz_zhiya':'上市公司-质押',
    'company_dcrz_zhiyajc':'上市公司-解质押',
    'company_dcrz_diya':'上市公司-抵押',
    'company_dcrz_diyajc':'上市公司-解抵押',
    'company_dcrz_dongjie':'上市公司-冻结',
    'company_dcrz_danbao':'上市公司-担保'
}

export default function (status) {
  return Status2CN[status]|| status
}



// WEBPACK FOOTER //
// ./src/filters/Status2CN.js